module.exports = __webpack_public_path__ + "img/icon_user_wghn.5c239e80.svg";